<script setup>
import { useI18n } from 'vue-i18n';
import { useCampaignSendsQuota } from 'dashboard/composables/useCampaignSendsQuota';

const { t } = useI18n();
const { remainingSends, sendsExhausted } = useCampaignSendsQuota();
</script>

<template>
  <p v-if="remainingSends != null" class="text-xs text-n-slate-11">
    {{ t('CAMPAIGN.QUOTA.REMAINING', { remaining: remainingSends }) }}
  </p>
  <p v-if="sendsExhausted" class="text-xs text-n-amber-11">
    {{ t('CAMPAIGN.QUOTA.EXHAUSTED') }}
  </p>
</template>
